var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8292 5.62922C11.0569 5.85703 11.0569 6.22636 10.8292 6.45416L7.9125 9.37078C7.68468 9.59854 7.31534 9.59854 7.08753 9.37078L4.17086 6.45416C3.94305 6.22636 3.94305 5.85703 4.17086 5.62922C4.39867 5.40143 4.76801 5.40143 4.99582 5.62922L7.50001 8.13336L10.0042 5.62922C10.232 5.40143 10.6014 5.40143 10.8292 5.62922Z",
    fill: "#777E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown4);
export default __webpack_public_path__ + "static/media/down4.d65a4eeb691dc92b8c2a1726f479c4b3.svg";
export { ForwardRef as ReactComponent };